import CategoryListView from "@/views/admin/categories/CategoryListView";

const meta = { middleware: ["auth"], roles: ["admin", "super_admin"] };

export default [
    {
        name: "admin.categories",
        path: "categories",
        component: CategoryListView,
        meta,
    },
];
